import { Component, Input, OnInit } from '@angular/core';
import {
  APPRAISAL_NAME,
  LAYOUT_NAME,
  MIN_STATUS,
} from '../../../../../shared/utils/constants';
import { AppraisalSectionModel } from '../../../../models/appraisal-section.model';
import { AppraisalModel } from '../../../../models/appraisal.model';
import { AppraisalService } from '../../../../services/appraisal/appraisal.service';
import { DashboardSectionService } from '../../../../services/dashboard-section/dashboard-section.service';

@Component({
  selector: 'app-appraisal-section',
  templateUrl: './appraisal-section.component.html',
  styleUrls: ['./appraisal-section.component.scss'],
  standalone: false,
})
export class AppraisalSectionComponent implements OnInit {
  // @Input() status: number;
  _status: number;
  get status(): number {
    return this._status;
  }

  @Input('status')
  set status(value: number) {
    this._status = value;
    this.getAppraisalData();
  }

  @Input() isRejected: boolean;

  public appraisalState: AppraisalSectionModel;
  public APPRAISAL_NAME = APPRAISAL_NAME;
  public LAYOUT_NAME = LAYOUT_NAME;
  public minStatus = MIN_STATUS;
  public httpError: boolean;

  constructor(
    private dashboardSectionService: DashboardSectionService,
    private appraisalService: AppraisalService,
  ) {}

  ngOnInit() {}

  private getAppraisalData() {
    if (this.status >= this.minStatus.appraisal) {
      this.dashboardSectionService.getAppraisalSectionData().subscribe(
        (response) => {
          this.appraisalState = response;
          if (
            this.appraisalState.appraisalDate === null ||
            this.appraisalState.appraisalAmount === 0
          ) {
            this.updateAppraisalData();
          }
        },
        (error) => (this.httpError = true),
      );
    }
  }

  updateAppraisalData() {
    this.appraisalService.getAppraisal().subscribe(
      (response) => {
        this.mapResponseAppraisal(response);
      },
      (error) => {
        this.httpError = true;
      },
    );
  }

  mapResponseAppraisal(appraisaData: AppraisalModel) {
    this.appraisalState.appraisalAmount = parseFloat(
      appraisaData.mortgagesAppraisalCrmData.appraisalAmount,
    );
    this.appraisalState.appraisalDate =
      appraisaData.mortgagesAppraisalCrmData.appraisalDate;
  }
}
